import axios from "axios";
import { Scene } from "phaser";

import { getCurrentDraw  } from '../utils';

export class SplashScene extends Scene {

    constructor() {
        super("SplashScene");
    }

    async preload() {

         // Retrieve parameters from localStorage
         const storedParamsJSON = localStorage.getItem('gameParams');
         const storedParams = JSON.parse(storedParamsJSON) || {};
 
         const token = storedParams['token'] || undefined;
         const brand = storedParams['brand'] || undefined;
         const gamecode = storedParams['gamecode'] || undefined;

        

         if(!token || !brand || !gamecode){
            
            //this.cameras.main.fadeout(500, 0, 0, 0);
            //this.scene.stop();
            this.scene.start("ErrorScene", {message: "An Error Occured"});
         }

        const base_url = `${import.meta.env.VITE_BACKEND_BASE_URL}:${import.meta.env.VITE_BACKEND_PORT}`;

        this.registry.set('gamecode', gamecode);

        // Create a global axios instance
        window.apiClient = axios.create({
            baseURL: base_url,
            headers: {
                'X-GA-ClientId': brand, // Add the X-GA-ClientId header
                'X-GA-Authentication-Token': token, // Add the X-GA-ClientSecret header
                'Content-Type': 'application/octet-stream', // Optional, depends on the server setup
            },
            mode: 'cors'
        });

       

        const response = await getCurrentDraw(gamecode);
        
        if(response === undefined){
            this.scene.start("ErrorScene", {message: "Network Error"});  
        }

        if(response.status !== 200 ){
            this.scene.start("ErrorScene", {message: "No Player Information"});
            return;
        }
        this.currentDrawInfo  = response.data

        // Access the "X-UserName" header
        const userName = response.headers['x-username'];

        if (userName) {
            this.registry.set('username', userName);
        } else {
            this.registry.set('username', "johndoe");
            console.log('X-UserName header not found', response.headers);
        }
        
        this.registry.set('my-tickets',this.currentDrawInfo.tickets);
        this.registry.set('currentDraw', this.currentDrawInfo);
        this.registry.set('lottery', this.currentDrawInfo.lottery);

        const main_camera = this.cameras.main.fadeOut(500, 0, 0, 0);
        // Fadeout complete
        main_camera.once("camerafadeoutcomplete", () => {
            this.scene.start("MainScene");
        });


        // var config = {
        //     google: {
        //         families: ['Noto Sans Hebrew']
        //     },
        //     testString: 'ש'
        //     // testString: { 'Noto Sans Hebrew': 'ש' }
        // };
        // this.load.rexWebFont(config);

        //      // Listen for font load completion
        //     this.load.once('complete', () => {
        //         console.log('Font loaded successfully!');
        //     });

    }

    create() {

        const BrandLogo = this.add.sprite(this.scale.width/2,this.scale.height/2, 'pack', 'play-arcade-logo.png').setOrigin(0.5).setScale(0.6)
        BrandLogo.setTint(0xeeeeee)
        const fx = BrandLogo.postFX.addShine(1, .2, 5);
        // Old Logo

        // const logo = this.add.image(this.scale.width / 2, this.scale.height / 2, "logo");
        // //logo.setDisplaySize(this.scale.width, this.scale.height);
        // //logo.setSize(this.scale.width, this.scale.height)
        // const myScale =  this.scale.width * 0.8
        // const myWidth = myScale / logo.height
        // const actualScale = logo.width / logo.height
        // console.log("myScale",myScale, myWidth, myScale/logo.width);
        // //logo.setSize(myScale, logo.height / myWidth )
        // logo.setScale(this.reduceToOneDecimal(myScale/logo.width))
        // //logo.setDisplaySize(myScale, logo.height / myWidth )
        // const fx = logo.postFX.addShine(1, .2, 5);


        // const that = this
        // WebFont.load({
        //     google: {
        //         families: ['Oswald:300,400,500,700', "Montserrat:300,400,500,700"]
        //     },
        //     active: function ()
        //     {
        //         that.time.addEvent({
        //             delay: 2000,
        //             callback: () => {
                      
        //             }
        //         });
        //     }
        // })

       
    }

    reduceToOneDecimal(floatNumber) {
        // Multiply by 10 to shift the decimal, then round, then divide by 10 to reduce back
        const reducedNumber = Math.round(floatNumber * 10) / 10;
    
        // Return the reduced number with one decimal place
        return reducedNumber;
    }

}